// +-------------------------------------------------------------
// | Created by WebStorm.
// +-------------------------------------------------------------
// | User: msmile
// +-------------------------------------------------------------
// | Date: 2023/9/23
// +-------------------------------------------------------------
// |Time: 14:41
// +-------------------------------------------------------------
import request from "@/utils/request";
export const grandRequest = (obj) => {
    if (obj?.data === true || obj?.auth_type === true){
        return obj.auth_url || `${obj.url}`;
    }else{
        if(obj?.auth_url) delete obj.auth_url;
        if(obj?.auth_type) delete obj.auth_type;
        return request(obj);
    }
}
export const stsToken = () =>
    request({
        url: '/tool/sts-token',
        method: 'post',
        data: {},
    })
